import { gql } from "@apollo/client"
import craftApolloClient from "./api/apollo"

import Head from 'next/head'
import Image from 'next/image'
import Link from 'next/link'

import { Header, HeaderShim } from '../fuselage/global/header/header'
import { Sidebar } from '../fuselage/layout/sidebar/sidebar'
import { SpeakerGrid } from '../fuselage/layout/speaker-grid/speaker-grid'
import HubspotForm from'../fuselage/components/hubspot-form/hubspot-form'

import CSS from '../css/app/speakers.module.css'

function Speakers({ seomatic, craftCmsProfiles }) {

	// seo

	let metaTitle = JSON.parse(seomatic.metaTitleContainer)
    let metaTags = JSON.parse(seomatic.metaTagContainer) 

	// speakers

	// console.log('cms profile data:', craftCmsProfiles)

	return (
		<>

			<Head>
                <title>{metaTitle.title.title}</title>

                <meta name="description" content={metaTags.description.content} />
                <meta name="referrer" content={metaTags.referrer.content} />
                <meta content={metaTags['og:locale'].content} property="og:locale" />
                <meta content={metaTags['og:site_name'].content} property="og:site_name" />
                <meta content={metaTags['og:type'].content} property="og:type" />
                <meta content={metaTags['og:url'].content} property="og:url" />
                <meta content={metaTags['og:title'].content} property="og:title" />
                <meta content={metaTags['og:description'].content} property="og:description" />
                <meta content={metaTags['og:image'].content} property="og:image"></meta>  
            </Head>

			<HeaderShim />

			<section className="block">
				<div className="container">

				<Sidebar size='medium' flipped>

					<main>

						<p className='fs-1 fw-600 lh-1 c-black caps maxw-40'>2023 Advisory Board</p>
						
						<SpeakerGrid decal="gap-sm mt-md">
							{craftCmsProfiles.map( speaker => (
								<div key={speaker.id}>
									<Link href={`/speakers/profile/${speaker.slug}`}>
										<a className={CSS.avatar}>
											<Image 
												src={speaker.avatar[0].url} 
												layout='fill'
												alt="profile picture"
											/>
										</a>
									</Link>
									<div>
										<p className='mt-xs'>
											<span className='fw-600'>
											{ speaker.title }</span> <br/>
											{ speaker.positions.length ? `${speaker.positions[0].jobTitle}` : null } <br/>
											{ speaker.positions.length ? speaker.positions[0].organisation : null } <br/>
											
										</p>
									</div>
								</div>
							))}
						</SpeakerGrid>

					</main>

					<aside>
						<div>
							<p className='fs-3 fw-600 c-black lh-2'>MORE ANNOUNCEMENTS ARE COMING. STAY IN THE LOOP.</p>
							<p className='maxw-60 my-sm'>If you haven&apos;t shared your details to stay updated about IDEEA, share your name and email and we will keep you updated.</p>
						</div>

						<HubspotForm portalId={'14527187'} formId={'caaf334d-9ee0-49c4-9940-8d014fbb09ba'} />
					</aside>

					</Sidebar>


				</div>
			</section>

		</>
	)
}

export async function getStaticProps() {

	const cmsData = await craftApolloClient().query({
        query: gql`
			query SEO {
				entry(site: "${process.env.SITE_HANDLE}", id: "22417") {
					title
					seomatic (asArray: true) {
						metaTitleContainer
						metaTagContainer
					}
				}
			}
        `
    })


	const craftCmsProfiles = await craftApolloClient().query({
        query: gql`
            query Profiles {
                entries(site: "${process.env.SITE_HANDLE}", section: "profileGroups", id: "22502") {
					... on profileGroups_default_Entry {
						id
						title
						profiles {
							... on profiles_profile_Entry {
								id
								slug
								title
								avatar {
									... on avatars_Asset {
										id
										url
										width
										height
									}
								}
								positions {
									... on positions_BlockType {
										id
										jobTitle
										organisation
									}
								}
								profile
							}
						}
					}
				}
            }
          
        `
	})

	return {
		props: { 
			seomatic: cmsData.data.entry.seomatic,
			craftCmsProfiles: craftCmsProfiles.data.entries[0].profiles
		}
	}
}

export default Speakers


